(function(global) {
    'use strict';

    function Tabs() {
        this.$tab = $('.screenshots__slider');
        this.$tabNavElements = $('.screenshots__nav-item');
    }

    Tabs.prototype.init = function() {
        var slider = this;

        slider.swiper = new Swiper('.screenshots__slider', {
            wrapperClass: 'screenshots__slider-wrap',
            slideClass: 'screenshots__slider-item',
            pagination: '.screenshots__bullets',
            bulletClass: 'screenshots__bullets-item',
            bulletActiveClass: 'active',
            simulateTouch: false,
            paginationClickable: true,
            onSlideChangeStart: function(swiper) {
                slider.$tabNavElements.removeClass('active');
                slider.$tabNavElements[swiper.activeIndex].classList.add('active');
            }
        });

        slider.addListener();
    };

    Tabs.prototype.addListener = function() {
        var slider = this;

        this.$tabNavElements.on('click', function() {
            var $navItem = $(this);
            var index = $navItem.index();

            slider.updateSlide(index);
        });
    };

    Tabs.prototype.updateSlide = function(index) {
        this.swiper.slideTo(index);
        this.updateControls(index);
    };

    Tabs.prototype.updateControls = function(index) {
        if (this.$tabNavElements[index]) {
            this.$tabNavElements.removeClass('active');
            this.$tabNavElements[index].classList.add('active');
        }
    };

    global.Tabs = Tabs || {};
})(window.wrike);



// WEBPACK FOOTER //
// ./assets/js/projects/home-enterprise/includes/tabs.js